import { shallowRef, toValue, watch, type MaybeRefOrGetter } from "vue"
import {
  getContainerQueryElement,
  isMobileDevice as isMobileDeviceFunc,
  isMobileMq as isMobileMqFunc,
  isMobileContainerMq as isMobileContainerMqFunc,
  isPWA as isPWAFunc
} from "@/helper/app/device-helper.ts"
import { Capacitor } from "@capacitor/core"
import { useEventListener, useResizeObserver } from "@vueuse/core"

export function useDeviceDetection(
  containerElement?: MaybeRefOrGetter<HTMLElement | null | undefined>
) {
  const isMobile = shallowRef(isMobileDeviceFunc())
  const isMobileMq = shallowRef(isMobileMqFunc())
  const isMobileContainerMq = shallowRef(false)
  const isPWA = shallowRef(isPWAFunc())
  const isCapacitor = shallowRef(Capacitor.isNativePlatform())

  const updateContainerMq = () => {
    const element = containerElement ? toValue(containerElement) : undefined
    isMobileContainerMq.value = isMobileContainerMqFunc(element)
  }

  useEventListener("resize", () => {
    isMobile.value = isMobileDeviceFunc()
    isMobileMq.value = isMobileMqFunc()
    updateContainerMq()
    isPWA.value = isPWAFunc()
    isCapacitor.value = Capacitor.isNativePlatform()
  })

  if (containerElement) {
    // Observe the @container ancestor because layout columns can resize without the input root changing first.
    useResizeObserver(
      () => getContainerQueryElement(toValue(containerElement)) ?? null,
      updateContainerMq
    )
    watch(() => toValue(containerElement), updateContainerMq, { immediate: true, flush: "post" })
  }

  return {
    isMobile,
    isMobileMq,
    isMobileContainerMq,
    isPWA,
    isCapacitor
  }
}
